<template>
  <v-layout column class="ma-0 pa-0">
    <vue-snotify></vue-snotify>
    <v-row>
      <v-col cols="12" xs="12" :sm="colsNumber" :md="colsNumber">
        <v-card class="mx-auto" flat width="100%">
          <v-card-title class="headline font-weight-regular justify-space-between primary--text">
            TOPICS
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2"
              fab
              dark
              color="primary"
              @click="changeWindowsFlag = !changeWindowsFlag; editResourceFlag = false"
            >
              <v-icon v-if="changeWindowsFlag === false" dark>icons8-plus-math-2</v-icon>
              <v-icon v-else dark>icons8-minus-3</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider class="secondary mx-4"></v-divider>
          <v-card-text class="text-left">

             <v-row>
          <v-col cols="12" xs="12" sm="6">
            <v-text-field
              outlined
              clearable
              v-model="search"
              append-icon="icons8-search-4"
              label="Search"
              @click:clear="clearSearch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6">
            <!-- // ! RG - Modified :items="tags" to :items="filterTags" -->
            <v-select
              outlined
              clearable
              multiple
              v-model="filterApplied"
              append-icon="icons8-filter-3"
              :items="filterTags"
              label="Filter topics"
            ></v-select>
          </v-col>
        </v-row>
      
            <!-- Item list testing needs update-->
            <v-item-group>
              <v-container>
                <v-row>
                  <v-col
                    v-for="(item, index) in filteredItems"
                    :key="index"
                    cols="12"
                    md="4"
                    class="topicsClick"
                  >
                    <v-img
                      v-if="item.photoURL === ''"
                      :aspect-ratio="16 / 9"
                      height="200"
                      src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                      @click="openResourceList(item); changeWindowsFlag = false; editTopicFlag= false"
                    ></v-img>
                    <v-img
                      v-else
                      :aspect-ratio="16 / 9"
                      height="200"
                      :src="item.photoURL"
                      @click="openResourceList(item); changeWindowsFlag = false; editTopicFlag= false"
                    ></v-img>
                    <!-- two buttons-->
                    <v-row class="pa-2 ma-2">
                      <h3>{{ item.name }}</h3>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        class="greyBackground"
        cols="12"
        xs="12"
        :sm="colsNumber"
        :md="colsNumber"
        v-if="changeWindowsFlag === true"
      >
        <!------Add topic in here import -->
        <AddTopic
          :filestackAPI="filestackAPI"
          :resourceList="resourceList"
          :changeWindowsFlag="changeWindowsFlag"
           v-on:close-topic="closeTopicWindows"
        ></AddTopic>
      </v-col>
      <!--edit-topics-col -->

      <!--edit-references-col-->
      <v-col
        cols="12"
        xs="12"
        :sm="colsNumber"
        :md="colsNumber"
        v-if="editResourceFlag === true"
        class="grey lighten-3"
      >
        <!-- Add the edit topic compoment here -->
        <EditTopic
          :filestackAPI="filestackAPI"
          :changeWindowsFlag="changeWindowsFlag"
          :editTopicFlag ="editTopicFlag"
          :openedTopic="openedTopic"
          :topicsList="topicsList"
          :resourceList="resourceList"
           v-on:close-window="closeEditWindows"
        ></EditTopic>
      </v-col>

      <!--edit-resources-form -->
    </v-row>
  </v-layout>
</template>

<script>
import AddTopic from "./AddTopic.vue";
import EditTopic from "./EditTopic.vue";

export default {
  name: "Topics",
  components: {
    AddTopic,
    EditTopic,
  },
  data: () => ({
    changeWindowsFlag: false, //open invite user window
    editTopicFlag: false, //edit topic flag
    editAresourceFlag: false,
    editResourceFlag: false,
    search:"",
    filterApplied: [],
    tags: ["Biology", "Physics", "Chemestry"], // TODO RG - Remove if not necessary
    tagsList: [], // ! RG - Added for Database Tag List

    //filestack integration
    filestackAPI: [],

    //topic list
    newArray: [],
    topicsList: [],
    resourceList: [],
    openedTopic: [],
  }),
  computed: {
    colsNumber() {
      if (
        this.changeWindowsFlag ||
        this.editResourceFlag ||
        this.editAresourceFlag
      ) {
        return 6;
      } else {
        return 12;
      }
    },
     filteredItems() {
      return this.$orderBy(
        this.topicsList.filter((item) => {
          if (!this.search && this.filterApplied.length === 0) return this.topicsList;
          else if (this.search && this.filterApplied.length === 0) {
            return (
              item.name.toLowerCase().includes(this.search.toLowerCase()) ||
              item.description.toLowerCase().includes(this.search.toLowerCase())
            );
          } else if (!this.search && this.filterApplied) {
            return item.tags.some(r => this.filterApplied.includes(r));
          } else if (this.search && this.filterApplied) {
            return (
              item.name.toLowerCase().includes(this.search.toLowerCase()) ||
              item.description
                .toLowerCase()
                .includes(
                  this.search.toLowerCase() &&
                    item.tags.some(r => this.filterApplied.includes(r))
                )
            );
          }
        }),
        "name"
      );
    },
    // ! RG - Added to filterTags
    filterTags() {
      var objTags = [];
      for (var i = 0; i < this.tagsList.length; i++) {
        objTags.push(this.tagsList[i].name);
      }
      return objTags;
    },
  },

  methods: {
     clearSearch() {
      this.search = "";
    },
     closeEditWindows() {
      this.editResourceFlag = false;
      this.editTopicFlag = false;
    },
    closeTopicWindows(){
      this.changeWindowsFlag = false;
    },
    openResourceList(item) {
      //console.log(JSON.stringify(item));
      this.openedTopic = item;
     // this.filterResourcesTopic(item.id);
     if(this.editResourceFlag === true){
       this.editResourceFlag = false;
     }
      this.editResourceFlag = true;
    },
    // filterResourcesTopic(id) {
    //   //console.log("hi" + id);
    //   this.newArray = this.resourceList.filter(function (item) {
    //     //  console.log("hi 2 "+ item.topicId);
    //     return id === item.topicId;
    //   });
    //   return this.newArray;
    // },

    
    // ! RG - Added readTagsFromDB as tag list had not been updated 
    readTagsFromDB() {
      var self = this;
      this.$firebase.db.collection("tags").onSnapshot((querySnapshot) => {
        self.tagsList = [];
        var Data = [];
        querySnapshot.forEach((doc) => {
          Data = doc.data();
          Data.id = doc.id;
          self.tagsList.push(Data);
        });
      });
    },


    readTopics() {
      var self = this;
      this.$firebase.db.collection("topics").onSnapshot((querySnapshot) => {
        self.topicsList = [];
        var Data = [];
        querySnapshot.forEach((doc) => {
          Data = doc.data();
          Data.id = doc.id;
          self.topicsList.push(Data);
        });
      });
    },
    readResources() {
      var self = this;
      this.$firebase.db.collection("resources").onSnapshot((querySnapshot) => {
        var Data = [];
        self.resourceList = [];
        querySnapshot.forEach((doc) => {
          Data = doc.data();
          Data.id = doc.id;
          self.resourceList.push(Data);
        });
      });
    },
    readFilestackAPI() {
      var self = this;
      self.filestackAPI = [];

      var Data = [];

      this.$firebase.db
        .collection("integrations")
        .where("integrationName", "==", "fsapikey")
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            Data = doc.data();
            Data.id = doc.id;
            self.filestackAPI.push(Data);
          });
        })
        .catch(function (error) {
        //  console.log("Error getting documents: ", error);
        });
    },
  },
  created() {
    this.readFilestackAPI();
    this.readTopics();
    this.readTagsFromDB(); // ! RG - Added to read Tags from DB
    this.readResources();
    //console.log(this.$store.getters.currUser.userID);
    //console.log(JSON.stringify(this.resourceList, null));
  },
  
};
</script>

<style>
.topicsClick {
  cursor: pointer !important;
}
</style>
